<template>
    <section
        :id="`element-${settings.id}`"
        class="elle-toggle padd-v"
        :class="{ 'f-screen': settings?.fullScreen }"
        :style="{ backgroundColor: settings?.color }"
    >
        <div class="container">
            <div class="grid12">
                <div class="l-col">
                    <UiHeadline
                        :settings="{
                            label: settings?.label,
                            headline: settings?.headline
                        }"
                    >
                        <template v-if="settings.filter" #additional>
                            <FormsToggleFilter :tags="tags" @on-change-filter="id => onChangeFilter(id)" />
                        </template>
                    </UiHeadline>
                </div>
                <div class="r-col">
                    <LoopsToggle :items="filteredItems" />
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import type { CmsItem } from '~/types/cms';

const props = withDefaults(
    defineProps<{
        settings?: CmsItem;
    }>(),
    {
        settings: () => ({})
    }
);

const settings = computed(() => props.settings);

const { $ScrollTrigger: ScrollTrigger } = useNuxtApp();

const currentFilter = ref(-1);

const tags = computed<CmsItem[]>(() => {
    const values: CmsItem[] = [];
    if (!settings.value?.faq?.length) return values;

    settings.value.faq.forEach((item: CmsItem) => {
        if (item.faqGroup.length) {
            values.push(...item.faqGroup);
        }
    });

    values.sort((a, b) => {
        const titleA = String(a.title ?? '');
        const titleB = String(b.title ?? '');
        if (titleA < titleB) return -1;
        if (titleA > titleB) return 1;
        return 0;
    });

    return [...new Map(values.map(item => [item.id, item])).values()];
});

const filteredItems = computed<CmsItem[]>(() =>
    settings.value?.faq?.length
        ? settings.value.faq.filter(
              (item: CmsItem) =>
                  item.faqGroup.filter((group: CmsItem) => (currentFilter.value !== -1 ? group.id == currentFilter.value : true)).length
          )
        : []
);

const onChangeFilter = (id: number) => {
    currentFilter.value = id;
    nextTick(() => ScrollTrigger.refresh(true));
};
</script>
